<script lang="ts">
  import { categories, currentCategory } from '../../store/products'

  const setCurrentCategory = (category) => {
    currentCategory.set(category)
  }
</script>

<div class="product-filters mt-8">
  <span class="uppercase mt-4">
    Filtruj:
  </span>

  {#each $categories as category}
    <button 
      class="border-2 border-blue-600 px-4 py-2 mx-2 capitalize mt-4" 
      class:bg-blue-600="{$currentCategory === category}"
      class:text-white="{$currentCategory === category}"
      on:click={() => setCurrentCategory(category)}
    >
      {category}
    </button>
  {/each}
</div>